<template>
  <CartCheckoutWrapper>
    <section class="section" id="page-order-received">
      <div class="container">
        <div class="row">
          <div class="col-sm-12" v-if="orderInfo.busy">
            <WaveSpinner/>
          </div>
          <div class="col-sm-12" v-else-if="orderInfo.error">
            <div class="error">{{orderInfo.error}}</div>
          </div>
          <div class="col-sm-12" v-else-if="orderInfo.details">
          <div class="order-info">
            <h3 class="title">Order Details</h3>

            <div class="alert alert-success active">Thank you, Your order has been {{receivedStatus}}.
            </div>

            <p>We've sent an order confirmation email to<strong> {{orderInfo.details.guest_email}}</strong></p>

            <ul class="order-details">
              <li class="order">
                <span id="detail-title">Order Number:</span> <strong>{{orderInfo.details.number}}</strong>
              </li>
              <li class="date">
               <span id="detail-title">Date:</span> <strong>{{orderInfo.details.date_placed.substring(0,10)}}</strong>
              </li>
              <li class="total">
                <span id="detail-title">Total:</span> <strong><span class="amount">${{(+orderInfo.details.total_incl_tax).toFixed(2)}}</span></strong>
              </li>
              <li class="method">
                <span id="detail-title">Payment Method:</span> <strong>{{orderInfo.details.payment_method || 'Credit Card'}}</strong>
              </li>
            </ul>
            </div>
            <SurveyLink/>
            <div class="box table-responsive">
              <OrderSummary></OrderSummary>
            </div>
          </div>
          <div class="col-sm-12" v-else>
            <div class="error">An error occurred, please go to the homepage</div>
          </div>
        </div>
      </div>
    </section>
  </CartCheckoutWrapper>
</template>
<script>
  import OrderSummary from './OrderSummary';
  import {mapGetters, mapActions} from 'vuex';
  export default {
    props: ['id'],
    computed: {
      ...mapGetters(['orderInfo']),
      receivedStatus() {
        return this.orderInfo.details.status === 'Waiting for Review' ? 'sent to admin for review' : 'received';
      }
    },
    methods: {
      ...mapActions(['loadLastOrder', 'setLastOrder'])
    },
    components: {
      OrderSummary
    },
    mounted() {
      console.log('this.id', this.id);
      if (this.id) this.setLastOrder(this.id);
      else this.loadLastOrder();
    }
  }
</script>

<style scoped lang="scss">
@import '~scss/colors';

  .section{
    max-width:1140px;
    margin:0 auto;
  }

  .container{
    padding: 1em 0;
  }

  #page-order-received {
    .order-details {
      display: table;
      width: 100%;
      background: $white;
      padding: 1em;
      margin: 30px 0 20px;

      li {
        display: table-cell;
        text-transform: uppercase;
        font-size: 15px;
        color: #999;
        width: 1%;

        strong {
          display: block;
          font-size: 18px;
          text-transform: none;
          font-weight: bold;
          color: #323237;
        }
      }
      @media (max-width: 768px) {
        li {
          display: flex;
          margin:.5em 0;
          width:100%
        }
        #detail-title{
          margin-right: .5em;
          line-height: 1.8;
        }
      }

      .box {
        .title {
          margin-top: 10px;
          padding-bottom: 15px;
          border-bottom: 1px solid $gray-2;
        }

        .table {
          margin-bottom: 0;
        }
      }
    }

    .order-info, .box {
      background: $white;
      border: 1px solid $gray-1;
      padding:1em;
      margin: 1em 0;
    }

    .alert {
      font-size: 14px;
      font-weight: 300;
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/pages/invoice/Invoice.vue